<!-- 枚举图组件 -->
<template>
  <vue-draggable-resizable :draggable="!locked" :h="height" :minHeight="100" :minWidth="100" :resizable="!locked"
                           :w="width"
                           :x="x" :y="y"
                           :z="index" @activated="activated=true" @deactivated="activated=false" @dragging="onDrag"
                           @dragstop="onStop"
                           @resizestop="onStop" @resizing="onResize"
                           style="border: 0">
    <div @dblclick="handleCmp('config',  componentIndex)"
         @dragover="allowSignalMeasureDrop"
         @drop="(event)=>dragToDashbordCmp(event, chartData, componentIndex)"
         class="table-switch">
      <el-tooltip content="双击配置枚举图" effect="dark" placement="right">
        <el-container style="width: 100%;height:100%">
          <el-header style="height: 60px;padding-left: 10px" v-show="!hideTitle">
            <div class="title">枚举图</div>
            <div @dblclick="(event)=>dbClick(event,dataSources[0].key)"
                 class="dataSourcesName">
              <span style="font-size: 14px;">{{ dataSources.length>0?dataSources[0].text:'' }}</span>
              <span style="font-size: 14px;margin-left: 20px">{{ currentValue }}</span>
              <span style="font-size:14px;float:right" v-show="currentIndex>0">满足条件{{currentIndex}}</span>
            </div>
          </el-header>
          <el-main style="padding: 0">
            <div style="width: 100%;height: 100%">
              <el-image :src="src" fit="fill" style="width: 100%;height: 100%">
                <div class="image-slot" slot="placeholder">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </div>
          </el-main>
        </el-container>
      </el-tooltip>
      <el-dialog :append-to-body="true"
                 :show-close="false"
                 :title="'枚举图配置'"
                 :visible.sync="showConfig"
                 style="padding-top: 0"
                 top="20vh"
                 width="700px">
        <div class="num-config" style="font-size: 14px;margin-bottom: 30px">条件数
          <el-input-number :max="5" :min="2" size="small" style="margin-left: 20px" v-model="num"></el-input-number>
          <el-checkbox style="margin-left: 20px" v-model="hideTitle">隐藏标题</el-checkbox>
          <el-checkbox v-model="locked">锁定</el-checkbox>
          <el-button @click="handleCmp('delete',  componentIndex)" size="small" style="float: right;margin-left: 10px"
                     type="danger">删除组件
          </el-button>
          <el-button @click="managePic" size="small" style="float: right" type="primary">管理图片</el-button>
        </div>
        <ul :key="i" style="margin-left: 20px" v-for="i in num">
          <li style="margin-top: 20px;font-size: 14px">
            <span v-if="i===1">IF</span>
            <span v-else-if="i===num">ELSE</span>
            <span v-else>ELSE IF</span>
            <span @dblclick="(event)=>dbClick(event)" class="name-wrapper"
                  style="font-weight: bold;color: #2258cc;margin-left: 10px" v-if="i!==num">{{ signalName }}</span>
            <el-select placeholder="给定条件" size="mini" style="width: 100px;margin-left: 20px" v-if="i!==num"
                       v-model="signal[i-1]">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in options">
              </el-option>
            </el-select>
            <el-input
              clearable
              placeholder="给定值"
              size="mini"
              style="width: 120px;margin-left: 20px"
              v-if="i!==num"
              v-model="value[i-1]">
            </el-input>
            <span style="margin-left: 10px;font-size: 14px" v-if="i!==num">THEN</span>
            <el-select placeholder="选择图片" size="mini" style="width: 150px;margin-left: 20px" v-model="pic[i-1]">
              <el-option
                :key="item.url"
                :label="item.name"
                :value="item.url"
                v-for="item in fileList">
              </el-option>
            </el-select>
          </li>
        </ul>
        <div class="dialog-footer" slot="footer">
          <el-button @click="cancelSet">取 消</el-button>
          <el-button @click="valueConfirm" type="primary">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :append-to-body="true"
        :show-close="false"
        :title="'图片集管理'"
        :visible.sync="showPicConfig"
        style="padding-top:0"
        top="20vh"
        width="600px">
        <el-upload
          :file-list="fileList"
          :http-request="uploadPic"
          action="/"
          list-type="picture"
          ref="uploadFileCmp">
          <div style="display:flex;float: right;width: 100%">
            <el-button size="small" type="primary">上传图片</el-button>
            <div class="el-upload__tip" slot="tip" style="margin-left: 20px">只能上传jpg/png文件，且不超过500kb</div>
          </div>
        </el-upload>
        <div class="dialog-footer" slot="footer">
          <el-button @click="confirmPic" type="primary">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import componentApi from '@/api/component';

export default {
  name: 'table-switch',
  data() {
    return {
      width: 284,
      height: 216,
      x: 0,
      y: 0,
      locked: false,
      hideTitle: true,
      showConfig: false,
      showPicConfig: false,
      num: 2,
      index: 500,
      activated: false,
      currentValue: '暂无数据',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      signal: [],
      value: [],
      pic: [],
      options: [{
        value: '===',
        label: '等于',
      }, {
        value: '!==',
        label: '不等于',
      }, {
        value: '>',
        label: '大于',
      }, {
        value: '<',
        label: '小于',
      }, {
        value: '>=',
        label: '大于等于',
      }, {
        value: '<=',
        label: '小于等于',
      }],
      fileList: [],
      currentIndex: 0,
    };
  },
  components: {},
  props: {
    // 当前组件的编号
    componentIndex: {
      ty: Number,
      required: true,
    },
    // 图表数据
    chartData: {
      type: Object,
    },
    // 数据源
    dataSources: {
      type: Array,
    },
  },
  watch: {
    chartData: {
      handler(newData) {
        const { chartData } = newData;
        if (chartData[0] !== undefined) {
          this.currentValue = chartData[0].values[0].value;
          this.switchPic();
        }
      },
      deep: true,
      immediate: true,
    },
    activated() {
      const _this = this;
      document.onkeydown = function (e) {
        const _key = window.event.keyCode;
        // 删除键删除组件
        if (_key === 46 && _this.activated === true) {
          _this.handleCmp('delete', _this.componentIndex);
        }
      };
    },
  },
  computed: {
    ...mapState('Engineering', ['dragTreeNodeType']),
    ...mapGetters('Engineering', ['getCurCmpStatus', 'getPanelData_cg']),
    resizekey() {
      return this.$store.state.Engineering.echartResizeKey;
    },
    uploadFiles() {
      return this.$refs.uploadFileCmp.uploadFiles;
    },
    componentId() {
      return this.getPanelData_cg[this.componentIndex].cid;
    },
    config() {
      let config = '';
      config += `${this.width}|`;
      config += `${this.height}|`;
      config += `${this.x}|`;
      config += `${this.y}|`;
      config += `${this.locked}|`;
      config += `${this.num}|`;
      config += `${this.hideTitle}|`;
      config += `${JSON.stringify(this.signal)}|`;
      config += `${JSON.stringify(this.value)}|`;
      config += `${JSON.stringify(this.pic)}`;
      return config;
    },
    signalName() {
      if (this.dataSources.length > 0) {
        if (this.dataSources[0].text.length > 10) {
          return `${this.dataSources[0].text.substring(0, 10)}...`;
        }
        return this.dataSources[0].text;
      }
      return '观测值';
    },
  },
  mounted() {
    this.getPictureConfig();
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['setAnchorPointId', 'setAnchorPointId', 'addSingnalToDashboaord', 'setAnchorKeyWord']),
    getFileList() {
      componentApi.getPictureInfos(this.componentId)
        .then((res) => {
          this.fileList = res;
          // 仅用于Dev环境
          if (process.env.NODE_ENV === 'development') {
            console.log('当前为开发环境');
            this.fileList.map((file) => {
              file.url = `http://blackbox.focusintec.com${file.url}`;
            });
          }
        })
        .catch(err => console.log(err));
    },
    switchPic() {
      let unsatisfiedFlag = true;
      const regex = /^[\d-\\.]+$/;
      for (let i = 0; i < this.num - 1; i += 1) {
        if (this.signal[i] !== undefined && this.value[i] !== undefined && this.value[i].length > 0 && this.pic[i] !== undefined) {
          if (!regex.test(this.value[i])) {
            this.$message.error(`给定值${this.value[i]}不合法`);
            this.value[i] = '';
          } else if (this.currentValue === '暂无数据') {
          } else if (!regex.test(this.currentValue)) {
            this.$message.error(`当前值${this.currentValue}不合法`);
            this.currentValue = '暂无数据';
          } else {
            const expression = this.currentValue + this.signal[i] + this.value[i];
            // eslint-disable-next-line no-eval
            if (eval(expression)) {
              this.src = this.pic[i];
              this.currentIndex = i + 1;
              unsatisfiedFlag = false;
              break;
            }
          }
        }
      }
      if (unsatisfiedFlag) {
        this.currentIndex = this.num;
        if (this.pic[this.num - 1] !== undefined) {
          this.src = this.pic[this.num - 1];
        } else {
          this.src = 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg';
        }
      }
    },
    valueConfirm() {
      this.switchPic();
      this.savePictureConfig();
      this.showConfig = false;
    },
    cancelSet() {
      this.showConfig = false;
    },
    managePic() {
      this.showPicConfig = true;
      this.showConfig = false;
    },
    confirmPic() {
      this.showPicConfig = false;
      this.showConfig = true;
      this.savePictureInfos();
    },
    dbClick(event) {
      event.stopPropagation();
      const arr = this.dataSources[0].key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(this.dataSources[0].key.substring(this.dataSources[0].key.lastIndexOf('.') + 1));
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId(str2);
      }, 50);
      console.log('vuex设置id', str2);
    },
    dragToDashbordCmp(event, chartData, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSingnalToDashboaord({ dragNode, componentIndex });
      this.$message.success(`枚举图成功绑定 ${dragNode.text}`);
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL) {
        event.dataTransfer.dropEffect = 'copy';
      } else if (this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleCmp(command, index) {
      switch (command) {
        case 'delete':
          if (this.getCurCmpStatus) {
            this.$message({
              message: '当前面板正在运行，请先进行关闭',
            });
            return;
          }
          this.$confirm('确定删除枚举图组件?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 确认删除
              this.showConfig = false;
              this.deleteCpt({ index });
            }).then(() => {
              this.$message({
                message: '删除成功！',
              });
            })
            .catch((err) => {
            });
          break;
        case 'config':
          this.getFileList();
          this.showConfig = true;
          break;
        default:
          break;
      }
    },
    handleExceed() {
      this.$message.warning('最多上传一张图片');
    },
    /**
             * 文件上传至服务器
             */
    uploadPic(uploadComponent) {
      componentApi.uploadPic(uploadComponent.file, this.componentId)
        .then(() => {
          this.$message.success(`正在上传${uploadComponent.file.name},请稍候`);
        })
        .catch((err) => {
          if (this.$refs.uploadFileCmp) {
            this.$refs.uploadFileCmp.clearFiles();
          }
          this.getFileList();
          this.$message({
            type: 'error',
            message: `图片上传失败(${err[0]})：${err[1]}`,
          });
        });
    },
    savePictureInfos() {
      const pictures = [];
      if (this.uploadFiles !== undefined) {
        this.uploadFiles.map((item) => {
          pictures.push(item.name);
        });
        componentApi.savePictureInfos(this.componentId, JSON.stringify(pictures)).then(() => {
          this.getFileList();
        });
      }
    },
    savePictureConfig() {
      componentApi.savePictureConfig(this.componentId, this.config);
    },
    getPictureConfig() {
      if (this.componentId) {
        componentApi.getPictureConfig(this.componentId)
          .then((res) => {
            if (res !== undefined) {
              const configArr = res.split('|');
              if (configArr.length !== 10) {
                return;
              }
              this.width = parseInt(configArr[0], 10);
              this.height = parseInt(configArr[1], 10);
              this.x = parseInt(configArr[2], 10);
              this.y = parseInt(configArr[3], 10);
              this.locked = JSON.parse(configArr[4]);
              this.num = parseInt(configArr[5], 10);
              this.hideTitle = JSON.parse(configArr[6]);
              this.signal = JSON.parse(configArr[7]);
              this.value = JSON.parse(configArr[8]);
              this.pic = JSON.parse(configArr[9]);
              this.switchPic();
            }
          });
      }
    },
    onResize(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    },
    onDrag(x, y) {
      this.x = x;
      this.y = y;
    },
    onStop(x, y) {
      if (this.x + this.width <= 20) {
        this.x = (this.width * (-1)) + 20;
      }
      if (this.y + this.height <= 20) {
        this.y = (this.height * (-1)) + 20;
      }
      this.savePictureConfig();
    },
  },
};

</script>

<style lang="scss" scoped>
  @import "../../style/mixin";

  .table-switch {
    width: 100%;
    height: 100%;
    background: #ffffff;
    overflow: hidden;

    .title {
      font-size: 16px;
      font-weight: bold;
      margin-top: 10px;
    }

    .dataSourcesName {
      z-index: 99;
      cursor: pointer;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/TableSwitch.vue